<!-- Template Group  -->
<ng-template #tmplGroup let-group="group">
  <div class="app-layout-layout-group node-item"
       [id]="'group-'+group['refGroupID']"
       [attr.data-id]="'group-'+group['refGroupID']" [attr.id]="'list-'+group['refGroupID']" >
    <div class="list-row app-cursor-link grid-1-auto app-list-row-group ">
      <div class="grid-auto-1"   (click)="listControl.visionControlToggle(group)">
        <div>
          <i class="search-action far fa-fw"
             [class.fa-minus]="group['#Items'] == 0"
             [class.disabled]="group['#Items'] == 0"
             [class.fa-caret-up]="group['isExpanded'] && group['#Items'] != 0"
             [class.fa-caret-down]="!group['isExpanded'] && group['#Items'] != 0"
          ></i>
        </div>
        <div [hidden]="VCGroup.editmode" class="app-space-left">
          <div class="list-primary-text">
            {{group['refGroupHeadline']}}
          </div>
          <div class="app-list-secondary-text">
            {{group['refGroupDesc']}}
          </div>
        </div>
        <app-viewer-folder-form #VCGroup
                                [hidden]="!VCGroup.editmode"
                                [viewerActions]="reference.Group"
                                [data]="{
                                          headline: group['refGroupHeadline'],
                                          description: group['refGroupDesc'],
                                          groupID: group['refGroupID'],
                                          groupUPT: group['refGroupUPT']}">
        </app-viewer-folder-form>
      </div>
      <div class="layout-1-auto"  [hidden]="VCGroup.editmode">
        <div class="list-metadata"  (click)="listControl.visionControlToggle(group)">
          <div class="typo-right">
            {{getRessource('cReceipts', {cItems: group['#Items']})}}
          </div>
        </div>
        <div class="app-tree-point app-cursor-link app-pad-right">
          <ng-container *ngIf="group['expandThreePointMenue']">
            <div>
              <i (click)="VCGroup.changeEditmode(); group['expandThreePointMenue'] = false"
                 class="search-action far fa-pencil"></i>
            </div>
<!--            <div>-->
<!--              <i class="search-action far fa-file-search" (click)="group['expandThreePointMenue'] = false"></i>-->
<!--            </div>-->
            <div>
              <i class="search-action far fa-trash-alt"
                 (click)="
                   group['expandThreePointMenue'] = false;
                   reference.Group.Delete(group['refGroupID'], group['refGroupUPT'])">
              </i>
            </div>
          </ng-container>
          <div [class.not-expand]="!group['expandThreePointMenue']"
               [class.expand]="group['expandThreePointMenue']">
            <i class="search-action far fa-ellipsis-v"
               (click)="group['expandThreePointMenue'] = !group['expandThreePointMenue']"></i>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngTemplateOutlet="tmplItemsList;
        context:{
          items:group['refItems']
        , groupId:group['refGroupID']
        , isExpanded:group['isExpanded']}">
    </ng-container>
  </div>
</ng-template>
<!-- Template ReceiptList -->
<ng-template #tmplItemsList let-items="items" let-id="groupId" let-isExpanded="isExpanded">
  <div class="content node-item" cdkDropList
       [cdkDropListData]="items" [attr.data-id]="'list-data-'+id" [attr.id]="'list-'+id"  [id]="'list-'+id"
       [cdkDropListConnectedTo]="ddControl.getConnected(id)"
       [cdkDropListSortingDisabled]="false"
       (cdkDropListDropped)="ddControl.eventHandler.onDrop($event)"
       [class.app-cdk-dragdrop-notreceiving]="isExpanded && items.length !== 0">
    <ng-container *ngIf="isExpanded">
      <div cdkDrag [cdkDragData]="ddControl.getDragData(receipt)" *ngFor="let receipt of items;index as i;"
           (cdkDragStarted)="ddControl.eventHandler.onDragStart($event)" [cdkDragRootElement]="'list-'+id"
           (cdkDragMoved)="ddControl.eventHandler.onDragMoved($event)">
        <ng-container *ngTemplateOutlet="tmplItem,
                                        context:{
                                          receipt:ddControl.getDragData(receipt),
                                          groupId:id}"></ng-container>
        <div class="app-cdk-drag-placeholder" *cdkDragPlaceholder></div>
      </div>
    </ng-container>
    <ng-container *ngIf="(!isExpanded || ((items && items.length === 0) || !items))">
      <div [class.app-dropZone-empty]="ddControl.dragging && !ddControl.dropAction.targetId.includes(id)"></div>
    </ng-container>
  </div>
</ng-template>
<!-- Template Receipt (Group Items) -->
<ng-template #tmplItem let-receipt="receipt" let-groupId="groupId">
  <div class="list-row app-pad-none list-row-auto-1"
       [attr.data-id]="'item-data-'+receipt['rcptID']"
       [id]="'item-'+receipt['rcptID']"
       [attr.id]="'list-'+groupId">
    <div class="app-grid-1-1">
      <div class="app-cdk-dragdrop-handle" cdkDragHandle>
        <i class="fa-grip-lines-vertical app-cursor-grab"
           [class.fas]="ddControl.dragging && listControl.isSelected(receipt)"
           [class.fal]="!(ddControl.dragging && listControl.isSelected(receipt))"></i>
      </div>
      <exg-checkbox [ngModel]="listControl.isSelected(receipt)"
                    *ngIf="((!groupId.includes('default') && !listControl.reference.allowSingleSelection)
                         || (groupId.includes('default') && !listControl.receipt.allowSingleSelection))
                         || listControl.isSelected(receipt)"
                    [tiny]="true" class="app-cursor-link">
      </exg-checkbox>
    </div>
    <app-receipt-list-item [receipt]="receipt"
                           [ngClass]="'app-pad-none app-pad-left_none'"
                           [config]="!groupId.includes('default') ? listControl.reference.itemConfig(receipt, groupId) : listControl.receipt.itemConfig(receipt)"
                           [containerClass]="'list-row-1-auto'">
    </app-receipt-list-item>
  </div>
</ng-template>
<!-- -->
<div class="content app-layout-reference-viewer"
     [class.app-layout-grid-1-2]="drawerControl.receiptList.visible"
     [class.grid-auto-1]="!drawerControl.receiptList.visible">
  <!-- Control -->
  <div class="grid-1-auto app-list-seperator span-layout">
    <div class="app-tree-point spawn-reverse">
      <ng-container  *ngIf="listControl['expandThreePointMenue']">
        <div *ngIf="false">
          <i class="search-action far fa-folder-open" (click)="listControl['expandThreePointMenue'] = false"></i>
        </div>
        <div>
          <i class="search-action far fa-folder-plus"
             (click)="reference.Group.Create(); listControl['expandThreePointMenue'] = false"></i>
        </div>
      </ng-container>
      <div [class.expand]="listControl['expandThreePointMenue']"
           [class.not-expand]="!listControl['expandThreePointMenue']">
        <i (click)="listControl['expandThreePointMenue'] = !listControl['expandThreePointMenue']"
           class="search-action far fa-ellipsis-v"></i>
      </div>
    </div>
  </div>
  <!-- List Content -->
  <div class="content app-layout-list-quickfilter app-border-right">
    <!-- Search Header -->
    <exg-search-bar (Search)="receiptList.search($event)" [placeholder]="getRessource('SearchHolder')"
                    *ngIf="drawerControl.receiptList.visible" class="span-layout">
      <ng-template #rightTemplate>
        <i (click)="referenceList.loadData()" class="search-action far fa-sync"></i>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action far fa-filter"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter #VCreceiptListFilterControl [visibility]="popup.visibility !== 'hidden'"
                            (onActivateFilter)="receiptList.pageChanged(1);popup.close()"
                            [MetaInfo]="receiptList.MetaInfo"
                            [showFilter]="true" [uiFilter]="receiptList.uiFilter"
                            [uiSort]="receiptList.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action far fa-sort-alt"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter (onActivateFilter)="receiptList.pageChanged(1);popup.close()"
                            [MetaInfo]="receiptList.MetaInfo" [visibility]="popup.visibility !== 'hidden'"
                            [showSort]="true" [uiFilter]="receiptList.uiFilter"
                            [uiSort]="receiptList.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <app-exg-dropdown>
          <ng-template #hostTemplate>
            <i class="search-action far fa-binoculars"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <app-exg-filter (onActivateFilter)="receiptList.pageChanged(1);popup.close()"
                            [MetaInfo]="receiptList.MetaInfo" [visibility]="popup.visibility !== 'hidden'"
                            [showSearch]="true" [uiFilter]="receiptList.uiFilter"
                            [uiSort]="receiptList.uiSort"></app-exg-filter>
          </ng-template>
        </app-exg-dropdown>
        <i (click)="listControl.receipt.toggle()"
           [class.c-green]="!listControl.receipt.allowSingleSelection"
           class="search-action far fa-list">
        </i>
      </ng-template>
    </exg-search-bar>
    <!-- Left List <not in references -->
    <ng-container *ngIf="drawerControl.receiptList.visible">
      <ng-container *ngTemplateOutlet=" tmplItemsList;
                                      context:{
                                        items:receiptList.data,
                                        groupId:'default-cdk-dropGroup',
                                        isExpanded:receiptList.data.length !== 0}">
      </ng-container>
    </ng-container>
    <!-- Left Actions -->
    <div [class.span-layout]="!drawerControl.receiptList.visible" class="app-drawer">
        <i class="search-filter-action far fa-file-export"
           (click)="reference.Item.Create(receiptList.selected)"
           [class.disabled]="receiptList.selected.length === 0"
           [tooltip]="'zu Referenzen verschieben'" flow="right"></i>
        <app-exg-dropdown #VCGroupDropDown>
          <ng-template #hostTemplate>
            <i class="search-filter-action far fa-inbox-in"
               [class.disabled]="receiptList.selected.length === 0"
               [tooltip]="getRessource('MoveGroup')" flow="left"></i>
          </ng-template>
          <ng-template #contentTemplate let-popup>
            <form class="md-menu content" style="max-height: calc(100vh - 8.25rem)"
                  *ngIf="receiptList.selected.length !== 0 && referenceList.dataGroup.length !== 0">
              <div class="layout-auto-1">
                <div class="md-menu-header">{{getRessource('PopupHeaderGruppen')}}</div>
                <div class="content">
                  <ng-container *ngFor="let group of referenceList.dataGroup; let i = index;">
                    <div class="md-menu-item"
                         (click)="reference.Item.Create(receiptList.selected, group['refGroupID']);">
                      {{group['refGroupHeadline']}}
                    </div>
                  </ng-container>
                </div>
              </div>
            </form>
          </ng-template>
        </app-exg-dropdown>
    </div>
  </div>
  <!-- List Content -->
  <div class="content">
    <div class="layout-auto-1">
      <!-- Right Search Header -->
      <exg-search-bar (Search)="referenceList.search($event)" [placeholder]="getRessource('SearchHolderRefList')">
        <ng-template #leftTemplate>
            <i class="search-action far app-space-right "
               (click)="drawerControl.receiptList.toggle()"
               [class.fa-chevron-double-left]="drawerControl.receiptList.visible"
               [class.fa-chevron-double-right]="!drawerControl.receiptList.visible">
            </i>
        </ng-template>
        <ng-template #rightTemplate>
          <i (click)="referenceList.loadData()" class="search-action far fa-sync"></i>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action far fa-filter"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter #VCreferenceListFilterControl
                              (onActivateFilter)="referenceList.pageChanged(1);popup.close()"
                              [MetaInfo]="referenceList.MetaInfo"
                              [showFilter]="true" [uiFilter]="referenceList.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="referenceList.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action far fa-sort-alt"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter (onActivateFilter)="referenceList.pageChanged(1);popup.close()"
                              [MetaInfo]="referenceList.MetaInfo"
                              [showSort]="true" [uiFilter]="referenceList.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="referenceList.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <app-exg-dropdown>
            <ng-template #hostTemplate>
              <i class="search-action far fa-binoculars"></i>
            </ng-template>
            <ng-template #contentTemplate let-popup>
              <app-exg-filter (onActivateFilter)="referenceList.pageChanged(1);popup.close()"
                              [MetaInfo]="referenceList.MetaInfo"
                              [showSearch]="true" [uiFilter]="referenceList.uiFilter"
                              [visibility]="popup.visibility !== 'hidden'"
                              [uiSort]="referenceList.uiSort"></app-exg-filter>
            </ng-template>
          </app-exg-dropdown>
          <i (click)="listControl.reference.toggle()"
             [class.c-green]="!listControl.reference.allowSingleSelection"
             class="search-action far fa-list">
          </i>
        </ng-template>
      </exg-search-bar>
      <!-- List: Derfault Group -->
      <div class="content">
          <div *ngIf="referenceList.dataGroup.length === 0" class="splash empty">
            <p>{{getRessource('zeroRows')}}</p>
          </div>
        <ng-container *ngFor="let groupItem of referenceList.dataGroup">
          <ng-container *ngTemplateOutlet="tmplGroup,context:{group:groupItem}"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</div>
